export default __webpack_public_path__ + "static/media/iconLoungeChairWhite.69126b1b.svg";